import styled from 'styled-components'
import breakpoints from '../../styles/breakpoints'

export const TopSection = styled.section`
  padding-top: ${props => props.theme.spacing.base600};
  background: linear-gradient(
      180deg,
      rgba(238, 238, 238, 0.03) 0%,
      rgba(238, 238, 238, 0.46) 0.01%,
      #eeeeee 100%
    ),
    url('/images/textures/gray-poly.jpg');

  p {
    color: ${props => props.theme.colors.typography.dark.subtext};
  }
`

export const BottomSection = styled.section`
  background: linear-gradient(180deg, rgba(41, 62, 82, 0.97) 0%, #071827 100%),
    url('/images/textures/PAC-Walls.jpg');

  clip-path: polygon(0 50px, 100% 0, 100% 100%, 0 100%);
  padding-top: 120px;
  padding-bottom: 120px;

  @media (min-width: ${breakpoints.md}) {
    clip-path: polygon(0 80px, 100% 0, 100% 100%, 0 100%);
    padding-top: 150px;
  }

  @media (min-width: ${breakpoints.xl}) {
    clip-path: polygon(0 120px, 100% 0, 100% 100%, 0 100%);
    padding-top: 180px;
  }
  margin-bottom: -1px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${props => props.theme.colors.typography.light.text};
  }

  p {
    color: ${props => props.theme.colors.typography.light.subtext};
  }
`
